import * as React from "react"

export const AchievementIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      d="m10 9.833-1.34 1.03q-.096.068-.199-.003-.102-.072-.06-.18l.517-1.682-1.357-1.013q-.105-.066-.058-.184.045-.117.175-.117h1.641l.517-1.676q.042-.11.164-.11t.164.11l.517 1.676h1.65q.13 0 .17.117.043.117-.062.184l-1.35 1.013.518 1.681q.042.11-.06.18-.103.072-.2.005zm0 7.734-3.308.64a.61.61 0 0 1-.551-.142.66.66 0 0 1-.245-.524v-4.543Q5 12.275 4.458 11.024A6.3 6.3 0 0 1 3.917 8.5q0-2.532 1.775-4.308Q7.468 2.417 10 2.417t4.308 1.775q1.775 1.776 1.775 4.308 0 1.293-.5 2.534-.5 1.242-1.5 1.985v4.522a.66.66 0 0 1-.245.524.61.61 0 0 1-.551.141zm0-4.067q2.084 0 3.542-1.459Q15 10.583 15 8.5q0-2.085-1.458-3.542Q12.083 3.5 10 3.5q-2.084 0-3.542 1.458T5 8.5t1.458 3.541Q7.917 13.502 10 13.5m-3.02 3.633 3.02-.707 3 .707v-3.388a5.3 5.3 0 0 1-1.436.63 6 6 0 0 1-1.564.208 6.4 6.4 0 0 1-1.575-.197 4.7 4.7 0 0 1-1.446-.641z"
    ></path>
  </svg>
)
